import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { RootState } from './app/store'
import Main from './main'

export default function MainGuard () {
	const { profile } = useSelector((state: RootState) => state.user)
	const [component, setComponent] = useState(<></>)
	const navigate = useNavigate();
	useEffect(() => {
		if (profile.id)
		{
			setComponent(<Main />)
		} else
		{
			navigate("/new")
		}
	}, [profile, navigate])

	return (
		<div>
			{component}
		</div>
	)
}
